import enums from '../enums/RdsLife.enums';
export default class RadioStation {
  constructor({ id, name, streamingUrl }) {
    this.id = id;
    this.name = name;
    this.streamingUrl = streamingUrl;
    this.tipologia = enums.modelTypes.RADIO_STATIONS;
  }
}
